/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DamageGroupFromJSON, DamageGroupToJSON, } from './';
export function DamageDictionaryValueFromJSON(json) {
    return DamageDictionaryValueFromJSONTyped(json, false);
}
export function DamageDictionaryValueFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'group': !exists(json, 'group') ? undefined : DamageGroupFromJSON(json['group']),
        'carId': !exists(json, 'carId') ? undefined : json['carId'],
    };
}
export function DamageDictionaryValueToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'group': DamageGroupToJSON(value.group),
        'carId': value.carId,
    };
}
